import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import MobileBar from "@/components/MobileBar";
import AnalyticsTracker from "@/components/AnalyticsTracker";
import PhoneClickTracker from "@/components/PhoneClickTracker";
import HomePage from "@/pages/HomePage";
import MetiersPage from "@/pages/MetiersPage";
import CommentPage from "@/pages/CommentPage";
import RamaDecoPage from "@/pages/RamaDecoPage";
import ContactPage from "@/pages/ContactPage";
import EstimationPage from "@/pages/EstimationPage";
import CataloguePage from "@/pages/CataloguePage";
import RdvPage from "@/pages/RdvPage";
import ProjectPage from "@/pages/ProjectPage";
import MonProjetPage from "@/pages/MonProjetPage";
import EspaceProjetPage from "@/pages/EspaceProjetPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import ZonePage from "@/pages/ZonePage";
import BlogPage from "@/pages/BlogPage";
import GuidePage from "@/pages/GuidePage";
import NotFoundPage from "@/pages/NotFoundPage";

function PublicLayout({ children }) {
  return (
    <>
      <Header />
      <main>{children}</main>
      <Footer />
      <MobileBar />
    </>
  );
}

function RequireAdmin({ children }) {
  const t = localStorage.getItem("rama_token");
  if (!t) return <Navigate to="/admin/login" replace />;
  return children;
}

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) { const el = document.querySelector(hash); if (el) { el.scrollIntoView(); return; } }
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Toaster position="top-center" richColors />
        <AnalyticsTracker />
        <PhoneClickTracker />
        <Routes>
          <Route path="/" element={<PublicLayout><HomePage /></PublicLayout>} />
          <Route path="/nos-metiers" element={<PublicLayout><MetiersPage /></PublicLayout>} />
          {/* Réalisations masquées temporairement — réactiver en restaurant cette route */}
          <Route path="/realisations" element={<Navigate to="/" replace />} />
          <Route path="/comment-ca-marche" element={<PublicLayout><CommentPage /></PublicLayout>} />
          <Route path="/rama-deco" element={<PublicLayout><RamaDecoPage /></PublicLayout>} />
          <Route path="/contact" element={<PublicLayout><ContactPage /></PublicLayout>} />
          <Route path="/blog" element={<PublicLayout><BlogPage tab="guides" /></PublicLayout>} />
          <Route path="/blog/zones-intervention" element={<PublicLayout><BlogPage tab="zones" /></PublicLayout>} />
          <Route path="/blog/:slug" element={<PublicLayout><GuidePage /></PublicLayout>} />
          <Route path="/renovation/:slug" element={<PublicLayout><ZonePage /></PublicLayout>} />
          <Route path="/zones-intervention" element={<Navigate to="/blog/zones-intervention" replace />} />
          <Route path="/guides" element={<Navigate to="/blog" replace />} />
          <Route path="/guides/:slug" element={<Navigate to="/blog" replace />} />
          <Route path="/estimation" element={<PublicLayout><EstimationPage /></PublicLayout>} />
          <Route path="/estimation/:projectId" element={<PublicLayout><EstimationPage /></PublicLayout>} />
          <Route path="/catalogue" element={<PublicLayout><CataloguePage /></PublicLayout>} />
          <Route path="/rdv/:projectId" element={<PublicLayout><RdvPage /></PublicLayout>} />
          <Route path="/projet/:accessToken" element={<PublicLayout><ProjectPage /></PublicLayout>} />
          <Route path="/mon-projet" element={<PublicLayout><MonProjetPage /></PublicLayout>} />
          <Route path="/espace/:token" element={<PublicLayout><EspaceProjetPage /></PublicLayout>} />
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin" element={<RequireAdmin><AdminDashboardPage /></RequireAdmin>} />
          <Route path="*" element={<PublicLayout><NotFoundPage /></PublicLayout>} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}
